import React, { memo } from 'react';
import { FormArray } from '@core/utils/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { FieldItem } from './FieldItem';
import { Button } from '@core/components/Button';

export interface SchedulingFieldsProps {
  form: FormArray<any>;
}

export const SchedulingFields = memo((props: SchedulingFieldsProps) => {
  const { form } = props;
  const items = useObservable(form.items$, []);
  return (
    <div>
      {items.map((item, index) => (
        <FieldItem key={item.uid} form={item} onRemove={() => form.removeAt(index)} />
      ))}
      <Button onClick={() => form.push()}>Add</Button>
    </div>
  );
});
